<template>
  <main>
    <section class="fk-contents">
      <p class="mod-form-btn"><a href="#" class="btn-base btn-sub has-icon take-counter" @click.prevent="execInCounter()">{{text.InCounter}}</a></p>
      <p class="mod-form-btn"><a href="#" class="btn-base btn-sub has-icon take-seat" @click.prevent="execInTable()">{{text.InTable}}</a></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
export default {
  name: 'FKMOTableOrderSelect',
  data () {
    return {
      text: {
        CanOrderMenu: null,
        InCounter: null,
        InTable: null
      }
    }
  },
  mixins: [ CommonMixin ],
  computed: {
    getOrderDetail () {
      return this.$store.getters.orderDetail
    }
  },
  methods: {
    execInCounter: function () {
      // テーブル番号をリセットする
      const orderDetail = this.getOrderDetail
      orderDetail.tableNumber = null
      this.$store.dispatch('setOrderDetail', orderDetail)

      this.$router.push({ name: 'PaymentMethod' })
    },
    execInTable: function () {
      this.$router.push({ name: 'TableOrderInput' })
    },
    initView: function () {
      // マウント後に画面出力する文字列を設定する
      this.text.CanOrderMenu = this.$i18n.t('ReceiveMethod.CanOrderMenu')
      this.text.InCounter = this.$i18n.t('ReceiveMethod.InCounter')
      this.text.InTable = this.$i18n.t('ReceiveMethod.InTable')
    }
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TableOrderSelect.vue